module.exports = __webpack_public_path__ + "static/media/myheroacademia.4b38dd7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/myheroacademia.jpg
// module id = 1484
// module chunks = 0